import { LinkIcon, XMarkIcon } from '@heroicons/react/24/outline';

export const DM_LINK_TITLE_ID = 'dm-link-modal-title';

interface DmModalHeaderProps {
    onClose: () => void;
    disabled: boolean;
}

export function DmModalHeader({ onClose, disabled }: DmModalHeaderProps) {
    return (
        <div className="px-6 pt-5 pb-4 flex items-start gap-3.5 shrink-0">
            <span className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-gray-100 text-gray-500">
                <LinkIcon className="h-4 w-4" />
            </span>
            <div className="min-w-0 flex-1">
                <h2 id={DM_LINK_TITLE_ID} className="text-[17px] font-bold text-gray-900">
                    Find or create in Dental Monitoring
                </h2>
                <p className="text-[13px] text-gray-600 leading-relaxed mt-1">
                    Links this practice to a DM doctor and one of their DM practices, and saves both
                    ids right away.
                </p>
            </div>
            <button
                type="button"
                onClick={onClose}
                disabled={disabled}
                className="w-8 h-8 rounded-lg hover:bg-gray-100 flex items-center justify-center text-gray-400 shrink-0 disabled:opacity-50"
                aria-label="Close"
            >
                <XMarkIcon className="h-4 w-4" />
            </button>
        </div>
    );
}
